import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  (theme) => ({
    headerContainer: {
      paddingTop: theme.spacing(3),
    },
    heading: {
      fontSize: "18px",
      fontWeight: "bold",
      fontColor: theme.palette.text.primary,
      marginBottom: theme.spacing(3),
    },
    content: {
      padding: theme.spacing(2),
    },
    formControl: {
      marginBottom: theme.spacing(2),
    },
    cancelBtn:{
      marginRight: theme.spacing(2),
      minWidth:'150px',
      [theme.breakpoints.down("sm")]:{
        marginBottom: theme.spacing(2)
      }
      
    },
    saveBtn:{
      minWidth:'150px',
      [theme.breakpoints.down("sm")]:{
        marginBottom: theme.spacing(2)
      }
      
    },

    profileSection: {
      [theme.breakpoints.up("md")]: {
        marginLeft: theme.spacing(16),
      },
    },
  }),
  { index: 999 }
);

export default useStyles;
